import React from "react";
import { withRouter } from "react-router";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import PatientWalletSummary from "./PatientWalletSummary";
import PatientWalletDetail from "./PatientWalletDetail";

const PatientWalletLiability = ({ match }) => {
  const { period, selectedClinic, apiPeriod } = useHeaderActions();
  const patientId = match.params.subReport;

  return !patientId ? (
    <PatientWalletSummary />
  ) : (
    <PatientWalletDetail
      patientId={patientId}
      period={period}
      apiPeriod={apiPeriod}
      selectedClinic={selectedClinic}
    />
  );
};

export default withRouter(PatientWalletLiability);
